import * as React from 'react';
import { resolve } from "inversify-react";
import autobind from "autobind-decorator";

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from "src/core/services/ui/dialog.service";
import { ProductListView } from "./product-list.view";
import { ProductListDataService } from "./product-list.data";

export class ProductListController extends React.Component<ControllerProps<any>, any> {
    protected dataService: ProductListDataService;

    @resolve
    protected dialogService: DialogService;

    @resolve
    protected toast: ToastNotifications;

    public constructor(props) {
        super(props);
        this.dataService = ProductListDataService.make();
    }

    public componentDidMount() {
        this.loadData();
    }

    @autobind
    protected onItemDoubleClicked(item: ProductSummary | string) {
        this.props.history.push(`/products/products/${typeof item == 'string' ? 'new/' + item : item.id}`);
    }

    @autobind
    protected loadData() {
        this.props.setBusy(true);
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);
		this.dataService.pageSize = 20;
        this.dataService.load(query => query)
            .then(() => this.props.setBusy(false))
            .catch(error => {
                this.props.setBusy(false)
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            });
    }

    public render() {
        return <ProductListView
            model={this.dataService}
            setBusy={this.props.setBusy}
            onItemDoubleClicked={this.onItemDoubleClicked}
            {...this.props } />
    }
}



// WEBPACK FOOTER //
// ./src/app/products/products/list/product-list.controller.tsx